import React, { createContext, useEffect, useState } from 'react';
import {createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, sendPasswordResetEmail, signInWithEmailLink} from 'firebase/auth';
import app from '../firebase/firebase.config';
import { getDatabase, ref, get, orderByChild, query, onValue } from "firebase/database";

export const AuthContext = createContext();

const auth = getAuth(app);

const UserContext = ({children}) => {
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(true);
    const [permission, setPermission] = useState('user');
    const [userList, setUserList] = useState([]);
    const [userInfo, setUserInfo] = useState();
    const googleProvider = new GoogleAuthProvider();

    const createUser = (email, password, name) =>{
        return createUserWithEmailAndPassword(auth, email, password, name);
    }

    const getUsers = async () => {
        // Reference to your collection
        const db = getDatabase();
        const userRef = ref(db, 'users');
        const users = [];
        const snapshot = await get(userRef)
        if (snapshot.exists()) {
            snapshot.forEach((childSnapshot) => {
                users.push({uid:childSnapshot.key, ...childSnapshot.val()});
            });
            const sortedUsers = users.sort((a, b) => {
                const surnameA = a.surname.toUpperCase();
                const surnameB = b.surname.toUpperCase();

                if (surnameA < surnameB) {
                    return -1;
                } else if (surnameA > surnameB) {
                    return 1;
                } else {
                    return 0;
                }
            });
            setUserList(sortedUsers);
        }
    }

    const signIn = (email, password)=>{
        return signInWithEmailAndPassword(auth, email, password);
    }

    const signInWithEmailLink = (email) => {
        return signInWithEmailLink(auth, email);
    }

    const resetPassword = (email) => {
        return sendPasswordResetEmail(auth, email)
    }

    const signInWithGoogle = () =>{
        return signInWithPopup(auth, googleProvider)
    }

    const logOut = () =>{
        localStorage.removeItem('userData');
        localStorage.removeItem('userPermission');
        setPermission(null);
        setUser(null);
        return signOut(auth);
    }

    useEffect(() =>{
        setLoading(true);
        // getUsers();
        const user = JSON.parse(localStorage.getItem('userData'));
        const permission = JSON.parse(localStorage.getItem('userPermission'));
        // Set the context state with the retrieved user data and permission
        setUser(user);
        setPermission(permission);
        setLoading(false);

        let unsubscribeUserDb = () => {};
        const unsubscribe = onAuthStateChanged(auth, currentUser =>{
            localStorage.setItem('userData', JSON.stringify(currentUser));
            unsubscribeUserDb();
            unsubscribeUserDb = () => {};
            if (!currentUser) {
                setUserList([]);
                return;
            }
            const db = getDatabase();
            get(ref(db, "users/" + currentUser?.uid)).then((userInfo)=>{
                if(userInfo.val()?.verified) {
                    setUser(currentUser);
                    setLoading(false);
                }
            })
            .catch((error)=>{
                console.error('error',error);
            })
            // admin status is only ever trusted from the `admins/` node, never
            // from a field on the user's own record (which they can write themselves)
            get(ref(db, "admins/" + currentUser?.uid)).then((snapshot)=>{
                if (snapshot.val() === true) {
                    setPermission('admin');
                    localStorage.setItem('userPermission', JSON.stringify('admin'));
                }
            })
            .catch((error)=>{
                console.error('error',error);
            })

            // the Rules only allow reading the `users` collection to a
            // verified/admin member, so this listener is only attached once
            // we know a user is signed in (it silently no-ops otherwise).
            const userRef = ref(db, 'users');
            unsubscribeUserDb = onValue(userRef, (userSnapshot) => {
                const users = [];
                if (userSnapshot.exists()) {
                    userSnapshot.forEach((childSnapshot) => {
                        users.push({ uid: childSnapshot.key, ...childSnapshot.val() });
                    });
                }

                const sortedUsers = users.sort((a, b) => {
                    const surnameA = a.surname.toUpperCase();
                    const surnameB = b.surname.toUpperCase();
                    if (surnameA < surnameB) {
                        return -1;
                    } else if (surnameA > surnameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                setUserList(sortedUsers); // Update state
            }, (error) => {
                console.error('error', error);
            });
        })
        return () =>{
            unsubscribeUserDb();
            unsubscribe();
        }
    }, [])

    useEffect(()=>{
        const db = getDatabase();
        get(ref(db, "users/" + user?.uid)).then((userInfo)=>{
        setUserInfo(userInfo.val());
        })
        .catch((error)=>{
        console.error(error)
        });
    },[user, loading])

    const authInfo = {user, userInfo, getUsers, userList, loading, permission, createUser, signIn, signInWithEmailLink, resetPassword, logOut, signInWithGoogle, setPermission}

    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default UserContext;